<mat-card class="mat-card-site mat-card-site-general" [ngClass]="{'mat-card-site-dialog': dialogRef}">
  <form [formGroup]="siteForm" (ngSubmit)="onSubmit()">
    <mat-card-header>
      <ng-container *ngIf="dialogRef; else noDialog">
        <div style="display: flex; flex-direction: column;">
          <mat-card-title>Création site</mat-card-title>
          <mat-card-subtitle>Informations générales</mat-card-subtitle>
        </div>
      </ng-container>
      <ng-template #noDialog>
        <mat-card-title>Informations générales</mat-card-title>
        <!-- <mat-card-subtitle>Informations générales</mat-card-subtitle> -->
      </ng-template>
    </mat-card-header>
    <mat-card-content class="mat-card-content-site">

      <div class="content-row" style="align-content: center;"
        *ngIf="!dialogRef || uiService.visibleByRole([Role.manager, Role.administrator])">
        <label class="content-row-label">Site du PACO</label>
        <span class="required-asterisk" *ngIf="isRequiredField('isPaco')">*</span>
        <mat-checkbox formControlName="isPaco" [disabled]="siteForm.get('isPaco')?.disabled ||false">
        </mat-checkbox>
      </div>

      <div class="content-row">
        <label class="content-row-label">Nom</label>
        <span class="required-asterisk" *ngIf="isRequiredField('name')">*</span>
        <mat-form-field class="content-row-input">
          <input matInput formControlName="name" type="text" autocomplete="off">
        </mat-form-field>
      </div>

      <div class="content-row" *ngIf="!dialogRef || uiService.visibleByRole([Role.manager, Role.administrator])">
        <label class="content-row-label">Superficie</label>
        <span class="required-asterisk" *ngIf="isRequiredField('area')">*</span>
        <mat-form-field class="content-row-input">
          <input matInput formControlName="area" type="number" autocomplete="off" numeric [decimals]="1" [control]="$any(siteForm).controls['area']">
          <span matSuffix>m²</span>
        </mat-form-field>
      </div>

      <!-- <div class="content-row">
          <label class="content-row-label">Type</label>
          <app-dock-type-list class="content-row-input" [control]="$any(siteForm).controls['dockType']">
          </app-dock-type-list>
        </div> -->

      <!-- <div class="content-row">
          <label class="content-row-label">Type d'acces</label>
          <app-access-type-list class="content-row-input" [control]="$any(siteForm).controls['accessType']">
          </app-access-type-list>
        </div> -->

      <div class="content-row" *ngIf="!dialogRef || uiService.visibleByRole([Role.manager, Role.administrator])">
        <label class="content-row-label">Mode</label>
        <span class="required-asterisk" *ngIf="isRequiredField('siteMode')">*</span>
        <app-site-mode-list class="content-row-input" [control]="$any(siteForm).controls['siteMode']">
        </app-site-mode-list>
      </div>

      <div formGroupName="address" class="mat-card-content-site" [ngClass]="{'mat-card-content-site-dialog': dialogRef}"
        style="width: 100%;">
        <div class="content-row">
          <label class="content-row-label">Adresse</label>
          <span class="required-asterisk" *ngIf="isRequiredField('address.address1')">*</span>
          <mat-form-field class="content-row-input">
            <input matInput formControlName="address1" type="text" autocomplete="off">
          </mat-form-field>
        </div>

        <div class="content-row">
          <label class="content-row-label">Localité</label>
          <span class="required-asterisk" *ngIf="isRequiredField('address.city')">*</span>
          <mat-form-field class="content-row-input">
            <input matInput formControlName="city" type="text" autocomplete="off">
          </mat-form-field>
        </div>

        <div class="content-row">
          <label class="content-row-label">Code Postal</label>
          <span class="required-asterisk" *ngIf="isRequiredField('address.zip')">*</span>
          <mat-form-field class="content-row-input">
            <input matInput formControlName="zip" type="number" autocomplete="off">
          </mat-form-field>
        </div>
      </div>
      <!--<div class="content-row" *ngIf="!siteDetail?.isCreationMode">
          <label class="content-row-label">Date de modification</label>
          <mat-form-field class="content-row-input">
            <input matInput formControlName="modifiedDate" type="datetime-local" autocomplete="off">
          </mat-form-field>
        </div>
        <div class="content-row" *ngIf="!siteDetail?.isCreationMode">
          <label class="content-row-label">Utilisateur</label>
          <mat-form-field class="content-row-input">
            <input matInput formControlName="modifiedUser" type="text" autocomplete="off">
          </mat-form-field>
        </div> -->

    </mat-card-content>
    <mat-card-actions class="site-card-action" style="margin-bottom: 0;">
      <button mat-raised-button color="warn" type="button" (click)="onDelete()"
        *ngIf="(siteDetail?.id || siteDetail?.site?.id ) && siteDetail?.isReadOnlyMode">
        <mat-icon>delete</mat-icon> {{ 'button.delete' | translate }}
      </button>
      <button mat-raised-button color="primary" type="button" (click)="onEdit()"
        *ngIf="(siteDetail?.id || siteDetail?.site?.id ) && siteDetail?.isReadOnlyMode">
        <mat-icon>edit</mat-icon> {{ 'button.edit' | translate }}
      </button>
      <button mat-raised-button color="warn" type="button" (click)="onCancel()"
        *ngIf="(siteDetail?.id || siteDetail?.site?.id ) && siteDetail?.isEditMode">
        <mat-icon>clear</mat-icon> {{ 'button.cancel' | translate }}
      </button>
      <button mat-raised-button color="primary" [disabled]="siteForm.invalid"
        *ngIf="siteDetail?.isEditMode || siteDetail?.isCreationMode">
        <mat-icon>save</mat-icon> {{ 'button.save' | translate }}
      </button>
    </mat-card-actions>
  </form>
</mat-card>

<mat-card class="mat-card-site mat-card-site-general" *ngIf="!data">
  <mat-card-header>
    <mat-card-title>{{ 'label.picture' | translate}}</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <carousel [cellWidth]="400" [height]="300">
      <div class="carousel-cell" *ngFor="let img of (imageArray || [])">
        <img [src]="'data:image/png;base64,' + img.picture" alt="Image" (click)="onPictureClick(img)">
      </div>
    </carousel>
    <div style="display: flex; justify-content: center;">
      <span>{{ imageArray.length }} / {{imageArrayMaxLength}} {{ 'label.max-picture' | translate }}</span>
    </div>
  </mat-card-content>

  <mat-card-actions class="site-card-action" style="margin-bottom: 0;"
    *ngIf="uiService.visibleByRole([Role.manager, Role.administrator])">
    <button mat-raised-button color="primary" type="button" (click)="onPostPicture()" [disabled]="upload"
      style="margin-top: 20px;" *ngIf="siteDetail?.id">
      <mat-icon>file_upload</mat-icon> {{ 'button.add-picture' | translate}}
    </button>
  </mat-card-actions>
</mat-card>

<input type="file" #fileUpload id="fileUpload" name="fileUpload" onclick="this.value=null;" style="display:none;"
  [accept]="pictureSiteType" />